module.exports = __webpack_public_path__ + "img/bust_dart_height.c5af67ea.png";